import React from 'react';
import { findDOMNode } from 'react-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FileInput, Dropdown } from 'wix-rich-content-ui-components';
import { ToolbarButton } from 'wix-rich-content-editor-common';
import { BUTTONS } from './buttons/keys.js';
import 'wix-rich-content-common';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class BaseToolbarButton extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "onComponentClickButtonTrigger", (clickState) => {
      const { keyName } = this.props;
      const { event, key } = clickState;
      key === keyName ? this.handleClick(event) : event.preventDefault();
    });
    __publicField(this, "handleFileChange", (files) => {
      if (files.length > 0) {
        const { helpers, onFilesSelected, settings } = this.props;
        const { handleFileSelection } = helpers;
        if (handleFileSelection) {
          handleFileSelection(__spreadValues({}, this.props));
        } else if (onFilesSelected) {
          onFilesSelected(this.props.pubsub, files);
        } else {
          const state = { userSelectedFiles: { files } };
          this.props.pubsub.update("componentState", state);
        }
      }
    });
    __publicField(this, "getBoundingRectForModalButton", (isActive) => {
      if (this.props.type === BUTTONS.PANEL && isActive) {
        const blockNode = findDOMNode(this);
        return blockNode.getBoundingClientRect();
      } else {
        return null;
      }
    });
    /* eslint-disable complexity */
    __publicField(this, "handleClick", (event) => {
      var _b, _c;
      event.preventDefault();
      if (this.props.disabled) {
        return;
      }
      const _a = this.props, {
        helpers,
        theme,
        t,
        anchorTarget,
        relValue,
        componentState,
        pluginType,
        keyName,
        pubsub,
        onClick,
        settings,
        uiSettings,
        modalStyles,
        modalStylesFn,
        blockKey
      } = _a, otherProps = __objRest(_a, [
        "helpers",
        "theme",
        "t",
        "anchorTarget",
        "relValue",
        "componentState",
        "pluginType",
        "keyName",
        "pubsub",
        "onClick",
        "settings",
        "uiSettings",
        "modalStyles",
        "modalStylesFn",
        "blockKey"
      ]);
      (_b = helpers == null ? void 0 : helpers.onToolbarButtonClick) == null ? void 0 : _b.call(helpers, {
        type: "PLUGIN",
        buttonName: keyName,
        pluginId: pluginType
      });
      if (this.props.type === BUTTONS.FILES && !this.shouldHandleFileSelection) {
        const updateEntity = pubsub.getBlockHandler("handleFilesAdded");
        if (settings && settings.handleFileSelection) {
          settings.handleFileSelection(updateEntity);
        } else if (helpers && helpers.handleFileSelection) {
          const multiple = !!this.props.multiple;
          helpers.handleFileSelection(
            void 0,
            multiple,
            updateEntity,
            void 0,
            this.props.componentData
          );
        }
        return;
      }
      const activeButton = ((_c = componentState.activeButton) == null ? void 0 : _c.keyName) === keyName && componentState.activeButton || { keyName, isActive: false };
      const isExternalModalButton = this.props.type === BUTTONS.EXTERNAL_MODAL;
      const isToggleButton = !(isExternalModalButton || this.props.type === BUTTONS.FILES);
      const isActive = !isToggleButton ? activeButton.isActive : !(activeButton.keyName === keyName && activeButton.isActive);
      componentState.activeButton = __spreadProps(__spreadValues({}, activeButton), {
        keyName,
        isActive,
        boundingRect: this.getBoundingRectForModalButton(isActive)
      });
      if (this.props.type === BUTTONS.PANEL) {
        this.props.displayPanel({ PanelContent: this.props.panelContent, keyName });
      }
      if (this.props.type === BUTTONS.INLINE_PANEL) {
        this.state.isActive ? this.props.hideInlinePanel() : this.props.displayInlinePanel({ PanelContent: this.props.panelContent, keyName });
      }
      if (isExternalModalButton) {
        if (helpers && helpers.openModal) {
          let appliedModalStyles = {};
          if (modalStyles) {
            appliedModalStyles = modalStyles;
          } else if (modalStylesFn) {
            appliedModalStyles = modalStylesFn({ buttonRef: event.target, pubsub });
          }
          const keyName2 = BUTTONS.EXTERNAL_MODAL;
          const modalProps = __spreadValues({
            componentState,
            keyName: keyName2,
            helpers,
            pubsub,
            anchorTarget,
            relValue,
            t,
            theme: theme || {},
            settings,
            uiSettings,
            modalStyles: appliedModalStyles,
            buttonRef: event.target,
            onReplace: (data, blockKey2) => {
              pubsub.update("componentData", data, blockKey2);
            },
            pluginId: pluginType,
            blockKey
          }, otherProps);
          helpers.openModal(modalProps);
        } else {
          console.error(
            "Open external helper function is not defined for toolbar button with keyName " + keyName
          );
        }
      }
      pubsub.set("componentState", componentState);
      onClick && onClick(pubsub);
    });
    /* eslint-enable complexity */
    __publicField(this, "onComponentStateChange", (componentState) => {
      if (componentState.activeButton) {
        const activeButton = componentState.activeButton;
        const isActive = activeButton.keyName === this.props.keyName && activeButton.isActive;
        this.setState({ isActive });
      } else if (this.state.isActive) {
        this.setState({ isActive: false });
      }
    });
    __publicField(this, "getIcon", () => {
      const { iconActive, icon, theme } = this.props;
      const ActiveIcon = iconActive || icon;
      const Icon = icon;
      return /* @__PURE__ */ React.createElement("div", { className: theme.icon }, this.state.isActive ? /* @__PURE__ */ React.createElement(ActiveIcon, null) : /* @__PURE__ */ React.createElement(Icon, null));
    });
    __publicField(this, "getDataHook", () => `baseToolbarButton_${this.props.keyName}`);
    __publicField(this, "renderToggleButton", (buttonWrapperClassNames, buttonClassNames) => {
      const { theme, t, tooltipTextKey, tabIndex } = this.props;
      const tooltipText = t(tooltipTextKey);
      const toggleButton = (
        /* eslint-disable jsx-a11y/no-static-element-interactions */
        /* @__PURE__ */ React.createElement("div", { className: buttonWrapperClassNames }, /* @__PURE__ */ React.createElement(
          "button",
          {
            className: buttonClassNames,
            "aria-label": tooltipText,
            tabIndex,
            "aria-pressed": this.state.isActive,
            "data-hook": this.getDataHook(),
            onClick: this.handleClick
          },
          this.props.children || this.getIcon()
        ))
      );
      return /* @__PURE__ */ React.createElement(ToolbarButton, { theme, tooltipText, button: toggleButton });
    });
    __publicField(this, "renderFilesButton", (buttonClassNames, styles) => {
      const {
        settings: { accept },
        theme,
        t,
        tooltipTextKey,
        tabIndex
      } = this.props;
      const tooltipText = t(tooltipTextKey);
      const replaceButtonWrapperClassNames = classNames(styles.buttonWrapper);
      const filesButton = /* @__PURE__ */ React.createElement("div", { className: replaceButtonWrapperClassNames }, /* @__PURE__ */ React.createElement(
        FileInput,
        {
          className: classNames(buttonClassNames),
          theme,
          tabIndex,
          dataHook: this.getDataHook(),
          onChange: this.handleFileChange,
          accept,
          multiple: this.props.multiple
        },
        this.getIcon()
      ));
      return /* @__PURE__ */ React.createElement(ToolbarButton, { theme, tooltipText, button: filesButton });
    });
    __publicField(this, "renderDropdownButton", (buttonWrapperClassNames, buttonClassNames) => {
      const _a = this.props, {
        pubsub,
        componentData,
        theme,
        onChange,
        getValue,
        t,
        tabIndex,
        tooltipTextKey,
        helpers,
        pluginType
      } = _a, props = __objRest(_a, [
        "pubsub",
        "componentData",
        "theme",
        "onChange",
        "getValue",
        "t",
        "tabIndex",
        "tooltipTextKey",
        "helpers",
        "pluginType"
      ]);
      const tooltipText = t(tooltipTextKey);
      const onToolbarButtonClick = (value) => {
        var _a2;
        return (_a2 = helpers == null ? void 0 : helpers.onToolbarButtonClick) == null ? void 0 : _a2.call(helpers, {
          type: "PLUGIN",
          buttonName: this.props.keyName,
          pluginId: pluginType,
          value
        });
      };
      const decoratedOnChange = (value) => {
        onToolbarButtonClick((value == null ? void 0 : value.label) || (value == null ? void 0 : value.value));
        return onChange(value, componentData, pubsub.store);
      };
      const decoratedGetValue = () => getValue(pubsub.store, t);
      const dropDownButton = /* @__PURE__ */ React.createElement("div", { className: buttonWrapperClassNames }, /* @__PURE__ */ React.createElement(
        Dropdown,
        __spreadValues({
          className: buttonClassNames,
          tabIndex,
          dataHook: this.getDataHook(),
          onChange: decoratedOnChange,
          getValue: decoratedGetValue,
          onClick: onToolbarButtonClick,
          theme
        }, props)
      ));
      return /* @__PURE__ */ React.createElement(ToolbarButton, { theme, tooltipText, button: dropDownButton });
    });
    __publicField(this, "render", () => {
      const { disabled, theme: themedStyles } = this.props;
      const { isActive } = this.state;
      const buttonWrapperClassNames = classNames(themedStyles.buttonWrapper);
      const buttonClassNames = classNames({
        [themedStyles.button]: true,
        [themedStyles.active]: isActive,
        [themedStyles.disabled]: disabled
      });
      let toolbarButton;
      switch (this.props.type) {
        case BUTTONS.FILES:
          if (!this.shouldHandleFileSelection) {
            toolbarButton = this.renderToggleButton(buttonWrapperClassNames, buttonClassNames);
          } else {
            toolbarButton = this.renderFilesButton(buttonClassNames, themedStyles);
          }
          break;
        case BUTTONS.DROPDOWN:
          toolbarButton = this.renderDropdownButton(buttonClassNames, themedStyles);
          break;
        default:
          toolbarButton = this.renderToggleButton(buttonWrapperClassNames, buttonClassNames);
          break;
      }
      return toolbarButton;
    });
    this.state = { isActive: false };
    const { settings, helpers } = props;
    this.shouldHandleFileSelection = !(settings && settings.handleFileSelection || helpers && helpers.handleFileSelection);
  }
  componentDidMount() {
    this.props.pubsub.subscribe("componentState", this.onComponentStateChange);
    this.props.pubsub.subscribe("onClickTrigger", this.onComponentClickButtonTrigger);
  }
  componentWillUnmount() {
    this.props.pubsub.unsubscribe("componentState", this.onComponentStateChange);
    this.props.pubsub.unsubscribe("onClickTrigger", this.onComponentClickButtonTrigger);
  }
}
BaseToolbarButton.propTypes = {
  type: PropTypes.string,
  keyName: PropTypes.string.isRequired,
  panelContent: PropTypes.func,
  theme: PropTypes.object.isRequired,
  pubsub: PropTypes.object.isRequired,
  componentData: PropTypes.object.isRequired,
  componentState: PropTypes.object.isRequired,
  helpers: PropTypes.object,
  onClick: PropTypes.func,
  onFilesSelected: PropTypes.func,
  onChange: PropTypes.func,
  getValue: PropTypes.func,
  children: PropTypes.object,
  multiple: PropTypes.bool,
  iconActive: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.element]),
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.element]),
  modalStyles: PropTypes.object,
  modalStylesFn: PropTypes.func,
  isMobile: PropTypes.bool,
  disabled: PropTypes.bool,
  t: PropTypes.func,
  tooltipTextKey: PropTypes.string,
  anchorTarget: PropTypes.string,
  relValue: PropTypes.string,
  tabIndex: PropTypes.number,
  displayPanel: PropTypes.func.isRequired,
  displayInlinePanel: PropTypes.func.isRequired,
  hideInlinePanel: PropTypes.func.isRequired,
  uiSettings: PropTypes.object,
  settings: PropTypes.object,
  pluginType: PropTypes.string,
  getUploader: PropTypes.func,
  blockKey: PropTypes.string
};
BaseToolbarButton.defaultProps = {
  settings: {}
};

export { BaseToolbarButton };
//# sourceMappingURL=baseToolbarButton.js.map
